<div class="d-flex align-items-center py-4 bg-body-tertiary vh-100">
    <main class="form-signin w-100 m-auto">
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <img class="mb-3 logo" ngSrc="/assets/logo_color_login.png" alt="VineMeds" width="200" height="57" priority>
            <div class="text-center">
                <span class="badge bg-dark">ADMIN</span>
            </div>

            <div class="h5 mb-3">Sign in</div>

            <div class="form-floating">
                <input type="email" class="form-control shadow-none" id="emailControl" formControlName="email" placeholder="name@example.com">
                <label for="emailControl">Email address</label>
            </div>

            <div class="form-floating">
                <input type="password" class="form-control shadow-none" id="passwordControl" formControlName="password" placeholder="Password">
                <label for="passwordControl">Password</label>
            </div>

            <button [disabled]="loading" class="btn btn-primary w-100 py-2">
                @if (loading) {
                    <span class="spinner-border spinner-border-sm me-1"></span>
                }
                Sign in
            </button>

            <div>
                <p routerLink="/account/forgot-password" class="mt-3 forgot-password-link text-body-secondary pointer">Forgot password</p>
            </div>

            <p class="mt-5 text-body-secondary">&copy; 2022–2026</p>
        </form>
    </main>
</div>
